var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "upload-photo-component" }, [
    _c(
      "div",
      {
        staticClass: "upload-photo-container",
        style: { backgroundImage: "url(" + _vm.imageUri + ")" },
        on: {
          mouseenter: function ($event) {
            _vm.hover = true
          },
          mouseleave: function ($event) {
            _vm.hover = false
          },
        },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: ["btn-edit-photo", { "full-opacity": _vm.hover }],
        on: {
          click: function ($event) {
            return _vm.$emit("click-add")
          },
        },
      },
      [_c("i", { staticClass: "fi fi-pencil" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }